import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const CestaRequest = () => ({
    getEmailSendingMessage: (cancelToken = null) => {
        return BaseRequest.axiosInst.get(`${API_URL}/cesta/get-email-sending-message`, {
            headers: BaseRequest.publicHeaders,
            cancelToken
        });
    }
})

export default CestaRequest();
